import React from "react";
import { StatusTitle, Status, Dot, SummarePanelHeaderContainer } from "./styled";

type SummaryPanelHeaderProps = {
  title: string;
  status: boolean;
};

const defaultProps: SummaryPanelHeaderProps = {
  title: "",
  status: false,
};

function SummaryPanelHeader({ title, status }: SummaryPanelHeaderProps) {
  return (
    <SummarePanelHeaderContainer>
      <StatusTitle>{title}</StatusTitle>
      {
        <Status>
          <Dot status={status}/>
          {status ? ( 'Completed' ) : ( 'InCompleted' )}
        </Status>
      }
    </SummarePanelHeaderContainer>
  );
}
SummaryPanelHeader.defaultProps = defaultProps;

export { SummaryPanelHeader };
